// Layer 3 seed: MTD cost-centre budget vs actual rows (Cost module table).

export type CostCentreSeed = {
  id: string;
  costCentre: string;
  budgetK: number;
  actualK: number;
};

/** MTD budget pace and actuals ($K, eight production days elapsed at the default cursor) — caption on Cost › Cost centres table. [syn] */
export const COST_CENTRES: readonly CostCentreSeed[] = [
  { id: 'cc-grind-media', costCentre: 'Grinding media', budgetK: 83, actualK: 91 },
  { id: 'cc-reagents', costCentre: 'Reagents', budgetK: 112, actualK: 106 },
  { id: 'cc-power', costCentre: 'Power', budgetK: 237, actualK: 244 },
  { id: 'cc-labour', costCentre: 'Labour', budgetK: 149, actualK: 147 },
  { id: 'cc-maintenance', costCentre: 'Maintenance', budgetK: 64, actualK: 71 },
];

export function costCentreMtdBudget(): number {
  return COST_CENTRES.reduce((sum, row) => sum + row.budgetK, 0) * 1_000;
}

export function costCentreMtdActual(): number {
  return COST_CENTRES.reduce((sum, row) => sum + row.actualK, 0) * 1_000;
}
